<div mat-dialog-content class="w-timepicker-dialog">
    <durationw-time [color]="color" [hideMeridian]="hideMeridian" [userTime]="userTime" (onRevert)="revert()" (onSubmit)="submit()" [revertLabel]="data.revertLabel" [submitLabel]="data.submitLabel"></durationw-time>
</div>
